export const environment = {
  production: true,
  allowOrigin:
    'backoffice-tst-webshop.jaga.com:443, backoffice-uat-webshop.jaga.com:443, backoffice-prd-webshop.jaga.com:443',
  occBaseUrl: null,
  prefix: '/occ/v2/',
  gtag: 'GTM-WPV26BF',
};
